import { Button, Input, Space, Table } from "antd";
import React, { useRef, useState } from "react";
import Style from "./FoodsListTabel.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import {PencilSquare, TrashFill} from "react-bootstrap-icons";

const FoodsListTabel = ({ openModal, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  let dataSource = [];
  let index = 1;
  data &&
    data.forEach((element) => {
      dataSource.push({
        ProductId: element.id,
        ProductName: element.name,
        off_price: element.off_price,
        prices: element.price,
        Supplier: element.supplier,
        SupplierId: element.supplier_id,
        price: element.off_price === "0" ? element.price : element.off_price,
        packed:element.packed,
      });
      index = index + 1;
    });
  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  const columns = [
    {
      title: "تصویر محصول",
      dataIndex: "productPic",
      key: "productPic",
      width: "10%",
      ...getColumnSearchProps("productPic", "نام محصول"),
      render: (text, record) => (
        <div className={Style.picHolder}>
          <img
            src={`https://cdn.barest.ir/product/m/${
              record.ProductId
            }.jpg?${randomNumberInRange(1, 1000000000000)}`}
            alt=""
          />
        </div>
      ),
    },
    {
      title: "نام محصول",
      dataIndex: "ProductName",
      key: "ProductName",
      width: "20%",
      ...getColumnSearchProps("ProductName", "نام محصول"),
      render:(text,record)=>(
        <p style={record.packed==="0"?{color:"red"}:null}>{text}</p>
      )
    },
    {
      title: "نام تامین کننده",
      dataIndex: "Supplier",
      key: "Supplier",
      width: "20%",
      ...getColumnSearchProps("Supplier", "نام تامین کننده "),
    },
    {
      title: "قیمت محصول",
      dataIndex: "price",
      key: "price",
      width: "20%",
      ...getColumnSearchProps("price", "قیمت محصول"),
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      width: "20%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => openModal(1, record)}
            className={Style.editBtn}
          >
            <PencilSquare />
          </button>
          <button
            onClick={() => openModal(2, record)}
            className={Style.deleteBtn}
          >
            <TrashFill />
          </button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }} className={Style.TabelHolder}>
      <Table
        pagination={{ pageSize: 50 }}
        columns={columns}
        dataSource={dataSource}
        scroll={{x:1500, y: 450 }}
        loading={data === null ? true : false}
      />
    </div>
  );
};

export default FoodsListTabel;
